import React from "react";
import { Pagination, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const PaginationComponent = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
  onItemsPerPageChange,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const hasPages = totalPages > 1;

  const clamp = (p) => Math.min(Math.max(1, p), totalPages);
  const goTo = (p) => {
    const next = clamp(p);
    if (next !== currentPage) onPageChange(next);
  };

  const getPageNumbers = () => {
    const maxVisible = 5;
    if (totalPages <= maxVisible) return Array.from({ length: totalPages }, (_, i) => i + 1);

    const pages = [];
    const start = Math.max(1, currentPage - 2);
    const end = Math.min(totalPages, currentPage + 2);
    if (start > 1) pages.push(1);
    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("...");
    if (end < totalPages) pages.push(totalPages);
    return pages;
  };

  const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endIndex = Math.min(totalItems, currentPage * itemsPerPage);

  return (
    <div className="pager">
      <div className="pager-range">{startIndex}–{endIndex} из {totalItems}</div>

      {hasPages && (
        <Pagination size="sm" className="custom-pagination m-0">
          <Pagination.First disabled={currentPage === 1} onClick={() => goTo(1)} />
          <Pagination.Prev disabled={currentPage === 1} onClick={() => goTo(currentPage - 1)} />
          {getPageNumbers().map((n, i) =>
            n === "..." ? (
              <Pagination.Ellipsis key={`e-${i}`} disabled />
            ) : (
              <Pagination.Item
                key={n}
                active={n === currentPage}
                onClick={() => goTo(n)}
                aria-current={n === currentPage ? "page" : undefined}
              >
                {n}
              </Pagination.Item>
            )
          )}
          <Pagination.Next disabled={currentPage === totalPages} onClick={() => goTo(currentPage + 1)} />
          <Pagination.Last disabled={currentPage === totalPages} onClick={() => goTo(totalPages)} />
        </Pagination>
      )}

      <Form.Select
  aria-label="Элементов на странице"
  className="pager-size"
  value={itemsPerPage}
  onChange={(e) => {
    const n = Number(e.target.value);
    onItemsPerPageChange(n);
    onPageChange(1);        // ← всегда на первую страницу
  }}
>
  {[10, 25, 50, 100].map((n) => (
    <option key={n} value={n}>{n} / стр.</option>
  ))}
</Form.Select>

    </div>
  );
};

PaginationComponent.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onItemsPerPageChange: PropTypes.func.isRequired,
};

export default PaginationComponent;
